class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.backdrop = this.querySelector('[data-fallback-cart-backdrop]');
    this.dragZone = this.querySelector('[data-fallback-cart-drag-zone]');
    this.header = document.querySelector('sticky-header');
    this.activeElement = null;
    this.dragStartY = null;
    this.dragDistance = 0;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((button) => button.addEventListener('click', this.close.bind(this)));
    this.backdrop?.addEventListener('click', this.close.bind(this));

    if (this.dragZone) {
      this.dragZone.addEventListener('touchstart', this.onDragStart.bind(this), { passive: true });
      this.dragZone.addEventListener('touchmove', this.onDragMove.bind(this), { passive: false });
      this.dragZone.addEventListener('touchend', this.onDragEnd.bind(this));
      this.dragZone.addEventListener('touchcancel', this.onDragEnd.bind(this));
    }
  }

  open() {
    this.notification.style.transform = '';
    this.notification.classList.add('animate');
    this.backdrop?.classList.add('active');
    document.documentElement.classList.add('fallback-cart-open');

    requestAnimationFrame(() => {
      this.notification.classList.add('active');
    });

    window.setTimeout(() => {
      if (!this.notification.classList.contains('active')) return;
      this.notification.focus();
      trapFocus(this.notification);
    }, 400);
  }

  close() {
    if (!this.notification.classList.contains('active')) return;
    this.notification.classList.remove('active');
    this.backdrop?.classList.remove('active');
    document.documentElement.classList.remove('fallback-cart-open');
    this.notification.style.transform = '';
    this.dragStartY = null;
    this.dragDistance = 0;

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target || !parsedState.sections?.[section.id]) return;
      const content = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (content !== null) target.innerHTML = content;
    });

    if (this.header) this.header.reveal();

    // Restart the restrained confirmation check when another item is added.
    const check = this.querySelector('.fallback-cart__check');
    if (check) {
      check.style.animation = 'none';
      void check.offsetWidth;
      check.style.animation = '';
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onDragStart(event) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    this.dragStartY = event.touches[0].clientY;
    this.dragDistance = 0;
    this.notification.style.transition = 'none';
  }

  onDragMove(event) {
    if (this.dragStartY === null) return;
    const currentY = event.touches[0].clientY;
    this.dragDistance = Math.max(0, currentY - this.dragStartY);
    if (this.dragDistance > 0) {
      event.preventDefault();
      this.notification.style.transform = `translateY(${this.dragDistance}px)`;
    }
  }

  onDragEnd() {
    if (this.dragStartY === null) return;
    this.notification.style.transition = '';

    if (this.dragDistance > 90) {
      this.notification.style.transform = '';
      this.close();
    } else {
      this.notification.style.transform = '';
    }

    this.dragStartY = null;
    this.dragDistance = 0;
  }
}

customElements.define('cart-notification', CartNotification);
